import { render, staticRenderFns } from "./bimContainer.vue?vue&type=template&id=7f28c32a&scoped=true&"
import script from "./bimContainer.vue?vue&type=script&lang=js&"
export * from "./bimContainer.vue?vue&type=script&lang=js&"
import style0 from "./bimContainer.vue?vue&type=style&index=0&id=7f28c32a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28c32a",
  null
  
)

export default component.exports